"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPLOAD_ERROR_FORM = void 0;
var UPLOAD_ERROR_FORM = exports.UPLOAD_ERROR_FORM = 'UPLOAD_ERROR_FORM';